import React from 'react';
import './BeforeAfter.css';

const items = [
  {
    beforeTitle: "Following up on a quote you sent last week",
    beforeDesc: "You meant to follow up on Thursday. It's now Monday. You search through your inbox for 10 minutes trying to find the email, then write a chase message from scratch \u2014 for every single lead.",
    beforeTime: "15\u201320 minutes, repeated for every lead",
    afterTitle: "It followed up automatically on day 3",
    afterDesc: "A personalised, friendly email went out automatically at the right moment. The customer clicked the link, accepted the quote online, and you got a notification. You were with another customer at the time.",
    afterTime: "Zero minutes from you. Every time.",
  },
  {
    beforeTitle: 'A customer asks "what are your opening hours?"',
    beforeDesc: "You stop what you're doing to reply. Or your phone buzzes at 9pm. Or they don't get an answer quickly enough and call someone else. This happens 15 times a day.",
    beforeTime: "Constant interruptions. All day. Every day.",
    afterTitle: "Answered instantly. Day or night.",
    afterDesc: "A chat on your website or a WhatsApp auto-reply handles hours, prices, FAQs, availability \u2014 everything routine. You only get involved when it's a real conversation worth having.",
    afterTime: "Saves 5\u20138 hours a week. Customers happier.",
  },
  {
    beforeTitle: "Figuring out how you're doing this month",
    beforeDesc: "You either wait for your accountant, or spend a Sunday evening trying to reconcile three spreadsheets. You're still not 100% sure the number is right.",
    beforeTime: "Hours. Monthly. Usually on a weekend.",
    afterTitle: "You see it on your phone right now",
    afterDesc: "Revenue today, this week, this month. Best-performing services. Outstanding invoices. A simple green or red \u2014 on track or behind. Updated every hour. In plain English.",
    afterTime: "Always live. Zero effort from you.",
  },
  {
    beforeTitle: "Chasing an overdue invoice",
    beforeDesc: "You've sent it twice already. It's now 45 days overdue. You don't want to be awkward, so you put off calling. Meanwhile, the cash is sitting in someone else's account.",
    beforeTime: "Stress. Awkward calls. Delayed cash flow.",
    afterTitle: "Friendly reminders go out automatically",
    afterDesc: "On day 7, day 14, day 30 \u2014 professional, polite reminders go out on their own. The right tone, the right timing. You get paid faster and never have to make an awkward call again.",
    afterTime: "Get paid 40% faster. Zero awkwardness.",
  },
];

const BeforeAfter: React.FC = () => {
  return (
    <section className="bfa-section" id="before-after">
      <div className="bfa-inner">
        <div className="bfa-head reveal">
          <span className="eyebrow">The difference smart automation makes</span>
          <h2>Your average Tuesday.<br /><em>Before</em> and after.</h2>
          <p>Real scenarios. No jargon. Just what actually changes.</p>
        </div>
        {items.map((item, i) => (
          <div className="bfa-item reveal" key={i}>
            <div className="bfa-before">
              <span className="bfa-lbl b">Before</span>
              <h3>{item.beforeTitle}</h3>
              <p>{item.beforeDesc}</p>
              <span className="bfa-time t-b">{item.beforeTime}</span>
            </div>
            <div className="bfa-arrow">&rarr;</div>
            <div className="bfa-after">
              <span className="bfa-lbl a">After</span>
              <h3>{item.afterTitle}</h3>
              <p>{item.afterDesc}</p>
              <span className="bfa-time t-a">{item.afterTime}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BeforeAfter;
